// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetInitialMembershipRequestRequestModel from '../../model/get-initial-membership-request-request-model';
import GetInitialMembershipRequestRequestDTO from '../dto/get-initial-membership-request-request-dto';
import dtoSchema from '../schemas/get-initial-membership-request-request-schema';

export default abstract class GetInitialMembershipRequestRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetInitialMembershipRequestRequestDTO>) {
    super();
    if (data) {
      this.userId = data.userId;
    }
  }
  /**
  * @type {int64}
  */
  userId?: number;

  static toModel(dto: DeepPartial<GetInitialMembershipRequestRequestDTO>): GetInitialMembershipRequestRequestModel;
  static toModel(dto: DeepPartial<GetInitialMembershipRequestRequestDTO> | undefined | null): GetInitialMembershipRequestRequestModel | undefined;
  static toModel(dto: DeepPartial<GetInitialMembershipRequestRequestDTO> | undefined | null): GetInitialMembershipRequestRequestModel | undefined {
    return dto ? new GetInitialMembershipRequestRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetInitialMembershipRequestRequestModel> | GetInitialMembershipRequestRequestModel): GetInitialMembershipRequestRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      userId: unwrapped.userId,
    } as GetInitialMembershipRequestRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetInitialMembershipRequestRequestModel, can not map to GetInitialMembershipRequestRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
